import { useEffect, useState } from 'react';
import Inputs from './components/Inputs';
import GridProvider from './components/GridProvider';
import { urls } from './api/urls';
import useHttp from '../../../hooks/use-http';
import Spinner from '../../UI/Modal/Spinner';
import MuiDialog from '../../UI/MuiDialog/MuiDialog';
import { useTranslation } from 'react-i18next';
import { handleErrorMessage } from '../../../../shared/api/handleErrorMessage';
import toast from 'react-hot-toast';

const INITIAL_VALUES = {
  id: 0,
  ime: '',
  prezime: '',
  email: '',
  brutoCena: '',
  inoBrutoCena: '',
  brutoCenaPrekovremena: '',
  idKategorijeZaposlenog: 0,
  nazivKategorijeZaposlenog: '',
};
const Zaposleni = ({ save, handleSave, novi, handleNovi }) => {
  const { t, i18n } = useTranslation();
  const { sendRequest, getData, data, isLoading } = useHttp('');
  const { sendRequest: vratiKupce, data: korisniciData } = useHttp('');
  const { sendRequest: vratiKategorije, data: kategorijeData } = useHttp('');

  const [formValues, setFormValues] = useState(INITIAL_VALUES);
  const [erpId, setErpId] = useState('');
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);

  const vratiZaposlene = () => {
    sendRequest({ url: urls.GET_ZAPOSLENI });
  };
  const fetchKupciData = () => {
    const config = {
      url: urls.GET_KUPCE,
    };
    vratiKupce(config);
  };
  useEffect(() => {
    fetchKupciData();
    vratiZaposlene();
    vratiKategorije({ url: urls.GET_KATEGORIJE });
  }, []);

  const handleSaveData = async () => {
    if (formValues.brutoCena === '0' || formValues.inoBrutoCena === '0') {
      toast.error('Cena ne moze biti 0');
      return;
    }
    const config = {
      method: 'POST',
      url: formValues.id !== 0 ? urls.UPDATE_ZAPOSLENI : urls.INSERT_ZAPOSLENI,
      data: {
        ...formValues,
        brutoCena: +formValues.brutoCena,
        inoBrutoCena: +formValues.inoBrutoCena,
        brutoCenaPrekovremena: +formValues.brutoCenaPrekovremena,
        ErpId: +erpId,
        idKorProm: +localStorage.idKorisnika,
      },
    };
    const result = await getData(config);
    if (result.id > 0) {
      vratiZaposlene();
      setFormValues(INITIAL_VALUES);
      setErpId('');
      toast.success(
        formValues.id === 0
          ? 'Uspešan unos podatak'
          : 'Uspešna izmena podataka',
      );
      return;
    }
    toast.error(handleErrorMessage(result));
  };
  useEffect(() => {
    if (save) {
      handleSaveData();
      handleSave(false);
    }
  }, [save]);
  useEffect(() => {
    if (novi) {
      handleNovi(false);
      setFormValues(INITIAL_VALUES);
    }
  }, [novi]);

  const handleOpenDeleteDialog = (id) => {
    setFormValues((curr) => {
      return { ...curr, id: id };
    });
    setOpenDeleteDialog(true);
  };
  const handleCloseDelete = () => {
    setFormValues(INITIAL_VALUES);
    setOpenDeleteDialog(false);
  };
  const handleEditData = async (item) => {
    console.log(item);
    setFormValues(item);
    setErpId(item.erpId);
  };
  const handleDelete = async () => {
    const config = {
      method: 'POST',
      url: urls.DELETE_ZAPOSLENI,
      data: { id: formValues.id },
    };
    const response = await getData(config);
    if (response > 0) {
      toast.success('Uspešano obrisan podatak');
      setFormValues(INITIAL_VALUES);
      setOpenDeleteDialog(false);
      vratiZaposlene();
      return;
    }
    toast.error('Greška prilikom brisanja podatka');
  };
  return (
    <div>
      {isLoading && <Spinner />}
      <Inputs
        formValues={formValues}
        setFormValues={setFormValues}
        korisniciData={korisniciData}
        kategorijeData={kategorijeData}
        erpId={erpId}
        setErpId={setErpId}
      />
      <GridProvider
        data={data}
        handleOpenDeleteDialog={handleOpenDeleteDialog}
        handleEditData={handleEditData}
        loading={isLoading}
      />
      <MuiDialog
        maxWidth="sm"
        open={openDeleteDialog}
        title={t('warning')}
        text={t('warningDelete')}
        handleClose={handleCloseDelete}
        handleConfirm={handleDelete}
        deniedText="ZATVORI"
      />
    </div>
  );
};

export default Zaposleni;
